class CreateOrgReq {
    constructor() {
        this.name = null;
        this.parentOrgId = null;
    }
}
export default CreateOrgReq;